export let env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );
if ( window.location.origin.indexOf( '://localhost' ) >= 0 ) {
    env = 'qa';
}

function getURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const permissionsURL = getURL( 'https://(env.)api.biw.cloud/v1/permissions-manager/getPermissions' );
export const companyURL = getURL( 'https://(env.)api.biw.cloud/v1/company-service' );
export const ecardURL = getURL( 'https://(env.)api.biw.cloud/v1/ecards' );
export const slackIntegrationURL = getURL( 'https://(env.)api.biw.cloud/v1/slack-integration' );
export const cmxURL = getURL( 'https://(env.)api.biw.cloud/v2/cmx' );
